import React, { Fragment, useMemo, useState } from "react";

import { IconWrap, OrderCardStyled } from "../orderHistory.styles";
import {
    OrderIcon,
    RightCaret,
} from "../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import { NormalText } from "../../../common/common.styles";
import { formatKoboToNaira } from "../../../../../utils/utilityFunctions";
import OrderDetails from "./orderDetailsPopup/OrderDetails";

const OrderCard = ({ order, activePage }) => {
    const [showOrderDetails, setShowOrderDetails] = useState(false);

    const totalPrice = useMemo(
        () => order.items?.reduce((total, item) => total + item.unitPrice * item.quantity, 0),
        [order],
    );

    const iconColors = useMemo(() => {
        if (activePage === 1) {
            return { bg: "#DCFFEC", outer: "#48D38A", inner: "#6DEAAB" };
        } else if (activePage === 2) {
            return { bg: "#DBF8FF", outer: "#1DCBEF", inner: "#7EE1F6" };
        } else {
            return "";
        }
    }, [activePage]);

    return (
        <Fragment>
            <OrderCardStyled onClick={() => setShowOrderDetails(true)}>
                <div className="catalogue__order-card-left">
                    <IconWrap bgColor={iconColors.bg}>
                        <OrderIcon colorInner={iconColors.inner} colorOuter={iconColors.outer} />
                    </IconWrap>
                    <NormalText>
                        {order.status === 2 ? order?.name ?? "-" : order.orderID}
                    </NormalText>
                </div>
                <div className="catalogue__order-card-right">
                    <NormalText>{formatKoboToNaira(totalPrice)}</NormalText>
                    <div>
                        <RightCaret />
                    </div>
                </div>
            </OrderCardStyled>
            {showOrderDetails && (
                <OrderDetails
                    orderData={order}
                    closeOrderDetails={() => setShowOrderDetails(false)}
                    totalPrice={totalPrice}
                />
            )}
        </Fragment>
    );
};

export default OrderCard;
